import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import EcosystemLandingImage from "../../assets/media/ecosystem-landing.png";
import "./index.css";

const property_manager = require("../../assets/media/portal_icons/Property_Manager.png");
const concierge_robot = require("../../assets/media/portal_icons/Concierge_Robot.png");
const cloud_community = require("../../assets/media/portal_icons/Cloud_Community.png");

let programmesData = [
  {
    icon: cloud_community,
    name: "Community",
    description: "Engaging users through content \n& retaining through reward.",
    features: [
      "Tokens",
      "Offers",
      "Polls",
      "Feeds",
      "Profiles",
      "Contacts",
      "Marketplace",
      "Events/Calendar",
    ],
    price: { range: "20p-£10 per user pcm", unit: "user" },
    url: "https://cloudcommunities.io",
    join: "Visit community app",
  },
  {
    icon: concierge_robot,
    name: "Concierge",
    description: "Chatbot personal assistant unlocks\ninsider access & value.",
    features: [
      "Premier upgrades & Access",
      "Mental Wellbeing",
      "Wellness",
      "Money Saver Assistant",
      "Home Services",
      "Travel Concierge",
      "Bespoke Brand Name Routings",
    ],
    price: { range: "£2.50-£5.50 per user pcm", unit: "user" },
    url: "https://aiconcierge.io",
    join: "Visit concierge app",
  },
  // {
  //   icon: property_manager,
  //   name: "Property",
  //   description: "Makes the dirty work in managing\nhomes look clean.",
  //   features: [
  //     "Serviced homes",
  //     "Inventory",
  //     "Referencing",
  //     "Communication & Tickets",
  //     "Management",
  //     "Repairs",
  //     "Compliance",
  //     "Cover",
  //     "Contractors"
  //   ],
  //   price: { range: "£5-£125", unit: "property" },
  //   url: "https://rentrobot.io",
  //   join: "Visit property app",
  //   propertyBrand: true
  // }
];
class Programmes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      loading: true,
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      Firebase.getBrandDataByID(brand, (brand_data) => {
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          loading: false,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
        });
      });
    }
  }

  showProgrammes = () => {
    const { is_property_brand, brand_name } = this.state;
    return programmesData.map((item, index) => {
      if (item.propertyBrand && !is_property_brand) return null;
      return (
        <div className="programme-content" key={index}>
          <div
            style={{
              backgroundImage: `url(${item.icon})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "contain",
              padding: 20,
              width: "100%",
              height: 70,
            }}
          ></div>
          <h1>{item.name}</h1>
          <p className="description">Programme</p>
          <p className="description">{item.description}</p>
          <div className="feature-container">
            {item.features.map((feature) => (
              <p>{feature}</p>
            ))}
          </div>
          <div className="price">{item.price.range}</div>
        </div>
      );
    });
  };

  gotoEcosystem = () => {
    const { brand_name } = this.state;
    window.open(
      `https://user.ecosystem.life/${brand_name
        .replace(/\s/g, "")
        .toLowerCase()}`
    );
  };

  render() {
    const {
      username,
      role,
      logo,
      brand,
      is_property_brand,
      loading,
      brand_name,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="content programmes-content">
            {loading ? (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            ) : (
              <React.Fragment>
                <div className="left">
                  <p class="your-ecosystem">Your Ecosystem</p>
                  <p class="description">Communicate, engage, reward.</p>
                  <img src={EcosystemLandingImage} alt="landing" />
                </div>
                <div className="right">
                  <button className="btn" onClick={this.gotoEcosystem}>
                    Click here to demo your branded user ecosystem
                  </button>
                  <div className="programmes-container">
                    {this.showProgrammes()}
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </main>
      </div>
    );
  }
}
export default Programmes;



// WEBPACK FOOTER //
// ./src/screens/Programmes/index.js